import React from 'react';
import { observer } from 'mobx-react';
import packagesCss from './packages.css';

import {
    BasicCard,
    BasicForm,
    IconTextButton,
    IIconTextButtonProps,
} from 'ui-lib';

import { useSnapshotStore } from '../../../../store';
import { ReleaseDetailsComponent, useReleaseDetails } from 'pages/private/components/release-info-component';

export interface IViewSnapshotPackageProps {
    title?: string;
    loadingState?: boolean;
    snapshotId: number;
    footerButtonProps: IIconTextButtonProps;
}

export const ViewSnapshotPackageComponent = observer((props: IViewSnapshotPackageProps) => {
    const snapshotStore = useSnapshotStore();

    const snapshotStates = useReleaseDetails({ releaseId: props.snapshotId, snapshotStore });
    return (
        <BasicCard
            className={packagesCss['release-details']}
            title={props.title}
            bordered={true}
            contents={
                <BasicForm
                    cardPros={{ bordered: false }}
                    items={[
                        <ReleaseDetailsComponent
                            key='detailedSnapshot'
                            showAllPackages={false}
                            release={snapshotStates}
                            packageTableTitle='Selected packages'
                        />,
                        <IconTextButton key='button' className={packagesCss.button} {...props.footerButtonProps} />,
                    ]}
                />
            }
        />
    );
});